import React, { useRef } from 'react';
import { useForm } from 'react-hook-form';
import ReCAPTCHA from 'react-google-recaptcha';
import { FiCalendar } from 'react-icons/fi';
import { FaWhatsapp, FaGlobe, FaCloud, FaLock } from 'react-icons/fa6';
import './Contact.scss';

export default function Contact() {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const recaptchaRef = useRef(null);

  const onSubmit = async (data) => {
    const recaptchaValue = recaptchaRef.current ? recaptchaRef.current.getValue() : null;
    
    if (!recaptchaValue) {
      alert("Por favor, verifica que no eres un robot");
      return;
    }

    const textoHtml = `
      <h3>Nuevo prospecto desde Landing Empresas y PYMES</h3>
      <p><strong>Nombre completo:</strong> ${data.nombre}</p>
      <p><strong>Nombre de tu empresa:</strong> ${data.empresa}</p>
      <p><strong>WhatsApp:</strong> ${data.whatsapp}</p>
      <p><strong>Correo electrónico:</strong> ${data.correo}</p>
      <p><strong>Servicio de interés:</strong> ${data.servicio}</p>
    `;

    const payload = {
      to: "contacto@despachozwolf.com",
      subject: `Nueva Asesoría Solicitada - ${data.empresa}`,
      text: textoHtml
    };

    try {
      const response = await fetch('http://despachozwolf.com/api/send-email.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const resultado = await response.json();

      if (resultado.status === 'Correo enviado con éxito') {
        alert("¡Asesoría solicitada con éxito!");
        reset();
        if (recaptchaRef.current) recaptchaRef.current.reset();
      } else {
        alert("Hubo un detalle en el servidor al enviar: " + resultado.status);
      }
    } catch (error) {
      console.error("Error enviando el formulario:", error);
      alert("No se pudo conectar con el servidor de correos.");
    }
  };

  return (
    <section className="contact-section-wrapper">
      
      {/* SECCIÓN PANORÁMICA CON EL FONDO Y DEGRADADO EXACTO DEL BOCETO */}
      <div 
        className="contact-main-section" 
        id="contacto" 
        style={{ 
          backgroundImage: `linear-gradient(to right, rgba(17, 24, 39, 0.4) 0%, rgba(15, 23, 42, 0.88) 45%, rgba(15, 23, 42, 0.98) 100%), url("/img/contabilidad.webp")`
        }}
      >
        <div className="contact-content-container">
          
          {/* COLUMNA IZQUIERDA: TEXTOS, REJILLA DE BENEFICIOS Y LÍNEAS GUÍA */}
          <div className="contact-left-info">
            <span className="contact-tag">ASESORÍA PERSONALIZADA</span>
            <h2 className="contact-heading">Lleva la contabilidad de tu empresa al siguiente nivel</h2>
            <p className="contact-subheading">
              Agenda una asesoría gratuita y descubre cómo podemos ayudarte a optimizar tus procesos contables, fiscales y financieros.
            </p>

            <div className="contact-benefits-row">
              <div className="benefit-item">
                <div className="benefit-icon-wrapper">
                  <FiCalendar />
                </div>
                <div className="benefit-text">
                  <h4>Asesoría sin costo</h4>
                  <p>Conoce cómo podemos ayudarte.</p>
                </div>
              </div>

              {/* Línea horizontal divisoria idéntica a la imagen */}
              <div className="benefit-divider-line"></div>

              <div className="benefit-item">
                <div className="benefit-icon-wrapper">
                  <FaWhatsapp />
                </div>
                <div className="benefit-text">
                  <h4>Respuesta rápida</h4>
                  <p>Te atendemos por WhatsApp en minutos.</p>
                </div>
              </div>
            </div>
          </div>

          {/* COLUMNA DERECHA: LA TARJETA BLANCA IMPECABLE */}
          <div className="contact-card-right">
            <div className="form-card-header">
              <h3>Agenda tu asesoría</h3>
              <p>Déjanos tus datos y nos pondremos en contacto contigo.</p>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="z-form">
              <div className="z-form-group">
                <input 
                  type="text" 
                  placeholder="Nombre completo" 
                  className={errors.nombre ? 'z-input error' : 'z-input'} 
                  {...register("nombre", { required: true })} 
                />
              </div>

              <div className="z-form-group">
                <input 
                  type="text" 
                  placeholder="Nombre de tu empresa" 
                  className={errors.empresa ? 'z-input error' : 'z-input'} 
                  {...register("empresa", { required: true })} 
                />
              </div>

              <div className="z-form-row">
                <div className="z-form-group half">
                  <div className="input-with-icon">
                    <FaWhatsapp className="inner-icon" />
                    <input 
                      type="tel" 
                      placeholder="WhatsApp" 
                      className={errors.whatsapp ? 'z-input error' : 'z-input'} 
                      {...register("whatsapp", { required: true })} 
                    />
                  </div>
                </div>

                <div className="z-form-group half">
                  <input 
                    type="email" 
                    placeholder="Correo electrónico" 
                    className={errors.correo ? 'z-input error' : 'z-input'} 
                    {...register("correo", { required: true })} 
                  />
                </div>
              </div>

              <div className="z-form-group select-group">
                <label className="z-select-label">Servicio de interés</label>
                <select 
                  className={errors.servicio ? 'z-select error' : 'z-select'} 
                  defaultValue="" 
                  {...register("servicio", { required: true })}
                >
                  <option value="" disabled>Selecciona una opción</option>
                  <option value="Contabilidad">Contabilidad Profesional</option>
                  <option value="Auditoria">Auditoría Fiscal/Financiera</option>
                  <option value="Finanzas">Optimización Financiera</option>
                  <option value="IMSS">Asesoría Pensiones IMSS</option>
                </select>
              </div>

                {/* RECAPTCHA Y BOTÓN DE ENVÍO */}
              <div className="z-action-row">
                <div className="z-captcha-container">
                    <ReCAPTCHA 
                    ref={recaptchaRef} 
                    sitekey="6LfFFKsUAAAAALSTw3iqSJ0liB7bxn0j8WFxyHdU"
                    size="compact" 
                    />
                </div> 
                
                <button type="submit" className="z-submit-btn">
                    Solicitar información <span className="btn-arrow">→</span>
                </button>
                </div>

              <div className="whatsapp-footer-link">
                <a href="https://wa.me/523325446331" target="_blank" rel="noreferrer">
                  <FaWhatsapp /> Hablar por WhatsApp
                </a>
              </div>
            </form>
          </div>

        </div>
      </div>

      {/* BARRA INFERIOR DEL DESPACHO (FOOTER ALINEADO SÚPER FINO) */}
      <footer className="contact-footer-bar">
        <div className="footer-bar-content">
          <div className="footer-logo">
            <h3>Zwolf<span>.</span></h3>
            <p>DESPACHO CONTABLE</p>
          </div>
          
          <div className="footer-badges">
            <div className="badge-item"><FaGlobe /> Atención en todo México</div>
            <div className="badge-item"><FaCloud /> Servicios 100% en línea</div>
            <div className="badge-item"><FaLock /> Información segura</div>
          </div>

          <div className="footer-copyright">
            <p>© 2024 Zwolf Despacho Contable. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>*
    </section>
  );
}